// extracted by mini-css-extract-plugin
export default {"Timer":"KR1GI","days":"eZU72","hours":"YCdE2","minutes":"titIC","seconds":"b-6TI","timeIcon":"_3VT9t","skeleton-progress":"awK9L"};